import { cva, cx, type VariantProps } from '@/cva.config';
import type { ReactNode } from 'react';

export const carouselSlideVariants = cva({
  base: 'embla__slide min-w-0 shrink-0 grow-0',
  variants: {
    intent: {
      category:
        'w-80 md:w-102.5 first:ml-6 md:max-lg:first:ml-10 lg:first:ml-20 last:mr-6 md:max-lg:last:mr-10 lg:last:mr-20 mr-6',
      pdp: 'basis-17/20 md:basis-11/20 first:ml-6 md:first:ml-10 last:mr-6 md:last:mr-10 mr-4',
      pricing:
        'first:w-[236.8px] first:ml-6 md:max-lg:first:ml-10 lg:first:ml-20 mr-4 lg:mr-6 last:mr-6 md:max-lg:last:mr-10 lg:last:mr-0',
      product: 'basis-8/10 md:basis-1/3 mr-6',
      quickPreview: 'basis-full',
      showcase:
        'basis-full bg-light-gray-50 rounded-lg flex items-center justify-center max-md:aspect-square mr-6',
      video:
        'first:ml-6 md:max-lg:first:ml-10 lg:first:ml-20 last:mr-6 md:max-lg:last:mr-10 lg:last:mr-20 w-81.75 md:w-113.25 lg:w-238.5 mr-6',
    },
  },
});

interface ReactCarouselSlideProps
  extends VariantProps<typeof carouselSlideVariants> {
  className?: string;
  children: ReactNode;
}

export const ReactCarouselSlide = ({
  children,
  className,
  intent,
}: ReactCarouselSlideProps) => (
  <div className={cx(carouselSlideVariants({ intent }), className)}>
    {children}
  </div>
);
